export default "__VITE_ASSET__DFavkb7G__"